{
  "distribution.new_tab": "opens in a new tab",

  "distribution.revision_generation": "r{revision} · generation {generation}",

  "distribution.website.title": "Website",
  "distribution.website.site": "Choose website",
  "distribution.website.empty_title": "No website yet",
  "distribution.website.empty_body": "No site has been set up for this organisation yet.",
  "distribution.website.base_locale": "Source language {locale}",
  "distribution.website.live_locales": "{count, plural, =0 {no language live yet} one {# language live} other {# languages live}}",
  "distribution.website.open_site": "View site",
  "distribution.website.channels": "Channels of this website",

  "distribution.channel.last_failed": "Last build failed",
  "distribution.channel.not_published": "Not published",
  "distribution.channel.open_live": "Open live site",
  "distribution.channel.open_preview": "Open preview",
  "distribution.channel.locales": "Languages",
  "distribution.channel.unreviewed": "unreviewed",
  "distribution.channel.gone_count": "{count, plural, one {# path returns 410} other {# paths return 410}}",
  "distribution.channel.none_production": "Nothing published to production yet.",
  "distribution.channel.none_preview": "No preview yet. Publish to preview to check the site with all languages internally.",
  "distribution.channel.live": "Live",
  "distribution.channel.hint_production": "For visitors, reviewed languages only",
  "distribution.channel.hint_preview": "Internal, including unreviewed languages",
  "distribution.channel.live_since": "live since",
  "distribution.channel.no_host": "No domain linked",
  "distribution.channel.unreviewed_title": "{locale}, unreviewed: preview only",
  "distribution.channel.unreviewed_count": "{count} unreviewed",
  "distribution.channel.failed_note": "Build r{revision} failed; the previous version stays live.",
  "distribution.channel.view_build": "View build",

  "distribution.strategy.full": "Full",
  "distribution.strategy.delta": "Delta (changes only)",
  "distribution.strategy.emergency_withdrawal": "Emergency withdrawal",

  "distribution.publish.action": "Publish",
  "distribution.publish.to_production": "To production",
  "distribution.publish.to_preview": "To preview",
  "distribution.publish.title": "Publish website",
  "distribution.publish.channel": "Channel",
  "distribution.publish.preview_hint": "Internal check, with all languages including unreviewed ones.",
  "distribution.publish.production_hint": "Live for visitors, published languages only.",
  "distribution.publish.reason": "Reason",
  "distribution.publish.reason_hint": "Shown in the publication history.",
  "distribution.publish.production_notice_title": "Goes live for visitors",
  "distribution.publish.production_notice": "Visitors see this version once the build is done and all release checks pass. If a check fails, the current version stays.",
  "distribution.publish.submit_preview": "Publish to preview",
  "distribution.publish.submit_production": "Publish to production",
  "distribution.publish.started": "Publication r{revision} started",
  "distribution.publish.started_body": "{channel}: the build is queued.",
  "distribution.publish.locales": "Languages: {locales}",

  "distribution.counts.properties": "Properties",
  "distribution.counts.excluded": "Excluded",

  "distribution.excluded.show_all": "Show all {count} properties",
  "distribution.excluded.show_less": "Show fewer",
  "distribution.excluded.none": "No properties excluded.",
  "distribution.excluded.no_website_right": "No website right",
  "distribution.excluded.text_missing_or_unreviewed": "Text missing or not reviewed",
  "distribution.excluded.stale_fact_conflict": "Text contradicts the facts",
  "distribution.excluded.no_publishable_cover": "No publishable cover photo",

  "distribution.builds.was_live": "Previously live",

  "distribution.build.title": "Build r{revision} · generation {generation}",
  "distribution.build.auto_refresh": "Refreshes by itself",
  "distribution.build.facts": "Details",
  "distribution.build.queued": "Queued",
  "distribution.build.finished": "Finished",
  "distribution.build.wait": "Waiting time",
  "distribution.build.pages": "Pages",
  "distribution.build.files": "{count, plural, one {# file} other {# files}}",
  "distribution.build.size": "Size",
  "distribution.build.log": "Log excerpt",
  "distribution.build.no_log": "No log excerpt available for this build.",
  "distribution.build.duration": "Duration",
  "distribution.build.strategy": "Build type",
  "distribution.build.by": "By",
  "distribution.build.reason": "Reason",
  "distribution.build.release": "Release",
  "distribution.build.code": "Code",
  "distribution.build.excluded": "{count, plural, one {# property excluded} other {# properties excluded}}",
  "distribution.build.log_pending": "The log excerpt follows when the build is done.",

  "distribution.checks.title": "Release checks",
  "distribution.checks.ok": "Passed",
  "distribution.checks.failed": "Failed",
  "distribution.checks.failed_count": "{count} of {total} failed",
  "distribution.checks.passed_count": "{count, plural, one {# check passed} other {all # checks passed}}",
  "distribution.checks.more": "and {count} more",
  "distribution.checks.none": "No checks recorded.",
  "distribution.checks.pending": "Checks follow when the build is done.",

  "distribution.check.private_data": "No private data",
  "distribution.check.html_basics": "HTML basics",
  "distribution.check.internal_links": "Internal links",
  "distribution.check.hreflang_reciprocity": "Language links (hreflang)",
  "distribution.check.sitemap": "Sitemap",
  "distribution.check.locales": "Home page per language",
  "distribution.check.no_fixture_in_production": "No unreviewed test texts live",
  "distribution.check.budgets": "Size budget",

  "distribution.releases.rollback": "Roll back",
  "distribution.releases.confirm_body": "Everyone sees this release immediately. Emergency withdrawals stay in force: withdrawn properties do not come back.",
  "distribution.releases.confirm": "Roll back to r{revision}",
  "distribution.releases.rolled_back": "{channel} rolled back to r{revision}",
  "distribution.releases.empty_title": "No releases yet",
  "distribution.releases.empty_body": "Releases appear here after the first production publication.",
  "distribution.releases.title": "Roll back",
  "distribution.releases.channel": "Channel",
  "distribution.releases.rollback_to": "Roll back to r{revision}, generation {generation}",
  "distribution.releases.confirm_title_production": "Roll production back to r{revision}?",
  "distribution.releases.confirm_title_preview": "Roll preview back to r{revision}?",
  "distribution.releases.built": "Built",
  "distribution.releases.empty_production": "After the first production publication you can roll back here.",
  "distribution.releases.empty_preview": "After the first preview publication you can roll back here.",
  "distribution.releases.show_all": "Show all {count}",
  "distribution.releases.show_less": "Show less",

  "distribution.withdrawals.lead": "Take a property off the live site immediately, without waiting for a build. For an expired right or an owner's request.",
  "distribution.withdrawals.action": "Withdraw property",
  "distribution.withdrawals.no_rights": "Only owners and administrators can withdraw a property right away.",
  "distribution.withdrawals.processing": "Withdrawal of {reference} in progress",
  "distribution.withdrawals.processing_body": "The background job updates the live site; this list refreshes by itself.",
  "distribution.withdrawals.removed": "{count, plural, one {# page removed} other {# pages removed}}",
  "distribution.withdrawals.gone_title": "Paths returning 410 (Gone)",
  "distribution.withdrawals.gone_body": "The live site returns 410 for these paths, even if an older release still contains them. Search engines then drop them from their index.",
  "distribution.withdrawals.title": "Emergency withdrawal",
  "distribution.withdrawals.gone_count": "{count, plural, one {# path returns 410} other {# paths return 410}}",

  "distribution.withdrawal_status.pending": "In progress",
  "distribution.withdrawal_status.applied": "Done",
  "distribution.withdrawal_status.failed": "Failed",

  "distribution.withdraw.title": "Take property off the website now",
  "distribution.withdraw.description": "Emergency withdrawal on all sites of this organisation.",
  "distribution.withdraw.property": "Property",
  "distribution.withdraw.property_placeholder": "Search by reference",
  "distribution.withdraw.property_hint": "Only properties with a valid website right.",
  "distribution.withdraw.reason": "Reason",
  "distribution.withdraw.reason_hint": "Required, at least 3 characters. Stored in the audit log and on the revoked right.",
  "distribution.withdraw.effects_title": "What happens right away",
  "distribution.withdraw.effect_live": "The property pages disappear in all languages from production and preview, and from the search index and sitemap.",
  "distribution.withdraw.effect_410": "The old addresses return 410 (Gone).",
  "distribution.withdraw.effect_right": "The property's website right is revoked.",
  "distribution.withdraw.effect_publish": "A new production publication without the property follows automatically.",
  "distribution.withdraw.confirm": "I understand this goes live right away",
  "distribution.withdraw.confirm_named": "I understand {reference} disappears from the live site right away",
  "distribution.withdraw.submit": "Withdraw now",
  "distribution.withdraw.started": "Withdrawal of {reference} started",
  "distribution.withdraw.started_body": "Follow the result under Previous withdrawals.",
  "distribution.withdraw.submit_named": "Withdraw {reference} now",

  "distribution.channels.title": "Portals",
  "distribution.channels.lead": "A generated or fetched feed does not yet mean a portal shows your properties.",
  "distribution.channels.accounts": "Channels of this organisation",
  "distribution.channels.registry": "Other portals in the register",
  "distribution.channels.col_channel": "Channel",
  "distribution.channels.col_evidence": "BRES evidence",
  "distribution.channels.col_missing": "Still needed",
  "distribution.channels.simulated": "Simulated",
  "distribution.channels.priority": "Priority {priority}",
  "distribution.channels.no_adapter": "No adapter",
  "distribution.channels.empty_title": "No channels",
  "distribution.channels.empty_body": "There are no portal accounts for this organisation yet.",
  "distribution.channels.kill_switch_on": "Kill switch on",
  "distribution.channels.kill_switch_notice": "No feeds or pushes go to this channel until you turn the kill switch off.",
  "distribution.channels.no_account_title": "No account",
  "distribution.channels.no_account": "This organisation has no account with this channel. Below you see how far BRES is and what is still needed.",
  "distribution.channels.missing_title": "Still needed",
  "distribution.channels.missing_none": "Nothing open for BRES as a product.",
  "distribution.channels.docs": "Sources",
  "distribution.channels.owner": "Owner: {owner}",
  "distribution.channels.and_more": "and {count} more",
  "distribution.channels.count": "{count, plural, one {# channel} other {# channels}}",
  "distribution.channels.listings": "properties",
  "distribution.channels.listings_of": "properties, limit {limit}",
  "distribution.channels.last_feed": "latest feed",
  "distribution.channels.delivery": "delivery",
  "distribution.channels.push_test": "Test push",
  "distribution.channels.rejected": "rejected",
  "distribution.channels.test_note": "Test adapter on this computer. Nothing goes to an external portal.",
  "distribution.channels.no_adapter_note": "BRES delivers nothing to {name} yet. The possible routes are under Evidence.",
  "distribution.channels.feed_note": "Feed ready to fetch. {name} has not fetched or accepted anything yet.",
  "distribution.channels.fetched_note": "{name} fetches the feed. Fetching is not acceptance.",
  "distribution.channels.detail_tabs": "Sections of this channel",
  "distribution.channels.tab_delivery": "Delivery",
  "distribution.channels.tab_evidence": "Evidence",
  "distribution.channels.tab_settings": "Settings",
  "distribution.channels.no_adapter_title": "No adapter yet",
  "distribution.channels.no_adapter_body": "BRES sends nothing to {name}. Evidence shows what is needed.",

  "distribution.kind.portal": "Portal",
  "distribution.kind.aggregator": "Aggregator",
  "distribution.kind.crm": "CRM",
  "distribution.kind.source": "Source",
  "distribution.kind.internal": "BRES format",
  "distribution.kind.test": "Test adapter",

  "distribution.evidence.title": "Evidence level",
  "distribution.evidence.ladder": "Evidence levels from low to high",
  "distribution.evidence.marker_product": "BRES",
  "distribution.evidence.marker_account": "This account",
  "distribution.evidence.candidate": "Candidate",
  "distribution.evidence.awaiting_contract": "Awaiting contract",
  "distribution.evidence.documented": "Documented",
  "distribution.evidence.implemented": "Built",
  "distribution.evidence.contract_tested": "Contract tested",
  "distribution.evidence.sandbox_accepted": "Accepted in test environment",
  "distribution.evidence.production_enabled": "Active in production",
  "distribution.evidence.degraded": "Degraded",
  "distribution.evidence.paused": "Paused",
  "distribution.evidence.mini_label": "This account: {account}. BRES: {product}.",

  "distribution.evidence_hint.candidate": "Considered as an option; no specification or contract.",
  "distribution.evidence_hint.awaiting_contract": "Access or specification still has to come from the provider.",
  "distribution.evidence_hint.documented": "Specification known; no adapter in BRES yet.",
  "distribution.evidence_hint.implemented": "Adapter exists in BRES; not checked against an official schema.",
  "distribution.evidence_hint.contract_tested": "Validated locally against the official schema. The portal has received nothing.",
  "distribution.evidence_hint.sandbox_accepted": "The portal accepted listings in a test environment.",
  "distribution.evidence_hint.production_enabled": "External evidence: the portal accepts listings from this account.",
  "distribution.evidence_hint.degraded": "Worked before, but returns errors now. Check the delivery status per property.",
  "distribution.evidence_hint.paused": "Stopped on purpose; nothing goes to this channel.",

  "distribution.cap.title": "What the channel supports",
  "distribution.cap.transport": "Delivery",
  "distribution.cap.transport_pull_snapshot": "Feed fetched by the portal",
  "distribution.cap.transport_push_api": "Push via API",
  "distribution.cap.transport_file": "File",
  "distribution.cap.transport_webhook": "Webhook",
  "distribution.cap.transport_unknown": "Not known yet",
  "distribution.cap.receipt": "Feedback",
  "distribution.cap.receipt_none": "None",
  "distribution.cap.receipt_fetched": "Only that the feed was fetched",
  "distribution.cap.receipt_accepted": "Acceptance per listing",
  "distribution.cap.receipt_listing_status": "Status per listing",
  "distribution.cap.receipt_unknown": "Not known yet",
  "distribution.cap.deletion": "Withdrawal",
  "distribution.cap.deletion_explicit": "Explicit withdrawal",
  "distribution.cap.deletion_missing_in_complete_snapshot": "Left out of the full feed",
  "distribution.cap.deletion_unsupported": "Not supported",
  "distribution.cap.deletion_unknown": "Not known yet",
  "distribution.cap.reconciliation": "Compare external state",
  "distribution.cap.locales": "Languages",
  "distribution.cap.locales_contract_defined": "Per contract",
  "distribution.cap.locales_unknown": "Not known yet",
  "distribution.cap.verified": "Checked on",

  "distribution.route.title": "Possible routes",
  "distribution.route.lead": "There is no public publishing contract for {name}. There are three routes; none has been chosen and BRES sends nothing to {name} now.",
  "distribution.route.a_title": "Direct partnership",
  "distribution.route.a_body": "BRES becomes a software partner with its own publishing access, its own feedback and comparison of the external state.",
  "distribution.route.a_condition": "Condition: acceptance as a partner. Lead time and costs are unknown.",
  "distribution.route.b_title": "Publishing partner",
  "distribution.route.b_body": "A party with existing access delivers on behalf of BRES.",
  "distribution.route.b_condition": "Condition: agree who manages changes and which statuses come back. Extra costs.",
  "distribution.route.c_title": "Client CRM keeps publishing",
  "distribution.route.c_body": "The agent's existing CRM serves the portal; BRES imports for the website and languages.",
  "distribution.route.c_condition": "Consequence: BRES then promises no publishing on this portal. Agree the source of truth per field.",
  "distribution.route.decision": "The choice is made at the pilot intake, before any quote that promises {name}. Only then follow specification, sandbox, adapter and acceptance.",

  "distribution.feed.title": "Feed",
  "distribution.feed.generate": "Generate and validate feed",
  "distribution.feed.generated": "{count, plural, one {Feed created with # property} other {Feed created with # properties}}",
  "distribution.feed.generated_invalid": "Feed invalid; the previous feed stays",
  "distribution.feed.not_accepted": "Generated and validated locally. {name} has not fetched or accepted this feed.",
  "distribution.feed.fetched": "{name} fetched the feed on {time}. Fetching does not mean the properties were accepted.",
  "distribution.feed.valid_title": "{count, plural, one {# property matches the schema} other {# properties match the schema}}",
  "distribution.feed.schema_kyero": "Validated against the official Kyero XSD v3.0.",
  "distribution.feed.schema_jamesedition": "Validated against our own schema based on the public JamesEdition documentation v3.9; no official schema exists.",
  "distribution.feed.invalid_title": "Feed does not match the schema",
  "distribution.feed.invalid_body": "This feed was not made live. The previous valid feed stays available.",
  "distribution.feed.in_feed": "In feed",
  "distribution.feed.errors": "Errors",
  "distribution.feed.warnings": "Warnings",
  "distribution.feed.created": "Created",
  "distribution.feed.state": "State",
  "distribution.feed.revision": "Website revision",
  "distribution.feed.hash": "SHA-256",
  "distribution.feed.issues": "Messages per property",
  "distribution.feed.view": "View feed",
  "distribution.feed.download": "Download XML",
  "distribution.feed.none": "No feed created yet. Generate one from the latest production publication.",
  "distribution.feed.none_short": "No feed yet",
  "distribution.feed.valid_short": "Valid",
  "distribution.feed.invalid_short": "Invalid",
  "distribution.feed.blocked_kill_switch": "The kill switch is on; no feed is created.",

  "distribution.artifact.live": "Current feed",
  "distribution.artifact.valid": "Valid",
  "distribution.artifact.invalid": "Invalid",
  "distribution.artifact.superseded": "Replaced",

  "distribution.delivery.generated": "In feed",
  "distribution.delivery.sent": "Sent",
  "distribution.delivery.fetched": "Fetched",
  "distribution.delivery.accepted": "Accepted by portal",
  "distribution.delivery.accepted_test": "Accepted by test adapter",
  "distribution.delivery.rejected": "Rejected",
  "distribution.delivery.withdrawn": "Withdrawn",
  "distribution.delivery.unknown": "Unknown",

  "distribution.listings.title": "Delivery status per property",
  "distribution.listings.lead": "What BRES knows per property. “In feed” means: in the generated feed, not placed yet.",
  "distribution.listings.lead_test": "Results from the test adapter. Simulated; there is no external portal.",
  "distribution.listings.limit": "Listing limit",
  "distribution.listings.empty_title": "No deliveries yet",
  "distribution.listings.col_property": "Property",
  "distribution.listings.col_status": "Status",
  "distribution.listings.col_external": "External ID",
  "distribution.listings.col_reason": "Reason",
  "distribution.listings.col_delivered": "Last delivery",
  "distribution.listings.search": "Search properties in this channel",
  "distribution.listings.search_placeholder": "Reference or title",
  "distribution.listings.all_statuses": "All ({count})",
  "distribution.listings.clear": "Clear filters",
  "distribution.listings.empty_filtered_title": "No properties with this filter",
  "distribution.listings.empty_filtered_body": "Clear the filters to see all deliveries.",
  "distribution.listings.empty_body_feed": "Generate a feed; the status per property appears here.",
  "distribution.listings.empty_body_test": "Send a test push; the outcome per property appears here.",
  "distribution.listings.empty_body_none": "Without an adapter BRES delivers nothing to this channel.",
  "distribution.listings.more": "Load {count} more",

  "distribution.test.title": "Test push",
  "distribution.test.notice_title": "Local test adapter",
  "distribution.test.notice": "Simulates a push portal on this computer: idempotency, timeouts, rate limits and rejections. Nothing goes to an external portal.",
  "distribution.test.property": "Property",
  "distribution.test.fault": "Simulate fault",
  "distribution.test.push": "Send test push",
  "distribution.test.reconcile": "Reconcile",
  "distribution.test.result_accepted": "Accepted by test adapter",
  "distribution.test.result_reconciled": "Found again after timeout",
  "distribution.test.result_unknown": "Outcome unknown",
  "distribution.test.result_rate_limited": "Rate limit reached",
  "distribution.test.result_rejected": "Rejected by test adapter",
  "distribution.test.explain_accepted": "Simulated acceptance. The external ID is stored; the next push updates the same listing.",
  "distribution.test.explain_reconciled": "No answer came, but the listing already existed. BRES took over the external ID instead of creating a duplicate.",
  "distribution.test.explain_unknown": "No answer came and the listing was not found. Reconcile before you push again.",
  "distribution.test.explain_rate_limited": "The adapter asked to try again later. The status stays unknown until the next attempt or a reconciliation.",
  "distribution.test.explain_rejected": "The adapter rejected the listing. The message is shown with the property in the delivery status.",
  "distribution.test.external_id": "External ID {id}",
  "distribution.test.reconciled": "{count, plural, =0 {No listings match} one {# listing matches} other {# listings match}}",
  "distribution.test.missing_remote": "{count, plural, =0 {Nothing missing at the test adapter} one {# missing at the test adapter} other {# missing at the test adapter}}",
  "distribution.test.unknown_remote": "{count, plural, =0 {No unknown listings at the test adapter} one {# unknown listing at the test adapter} other {# unknown listings at the test adapter}}",

  "distribution.fault.none": "No fault",
  "distribution.fault.timeout_after_commit": "Timeout after commit",
  "distribution.fault.rate_limited": "Rate limit (429)",
  "distribution.fault.reject": "Rejection",

  "distribution.fault_hint.none": "The test adapter accepts the listing.",
  "distribution.fault_hint.timeout_after_commit": "The listing is stored, but no answer comes back. BRES checks the external state first instead of creating it again.",
  "distribution.fault_hint.rate_limited": "The adapter refuses for now with 429; the status becomes unknown.",
  "distribution.fault_hint.reject": "The adapter rejects the listing with an error message.",

  "distribution.settings_form.status": "Account status",
  "distribution.settings_form.status_hint": "Levels above the BRES evidence, and acceptance by the portal, cannot be set by hand. They need external evidence.",
  "distribution.settings_form.limit": "Listing limit",
  "distribution.settings_form.limit_hint": "Maximum number of properties in the feed, if your portal package limits it.",
  "distribution.settings_form.note": "Note",
  "distribution.settings_form.kill_switch": "Kill switch",
  "distribution.settings_form.kill_switch_hint": "Stops creating feeds and pushes for this channel.",
  "distribution.settings_form.no_rights": "Only owners and administrators change channels.",
  "distribution.settings_form.saved": "{name} updated",
  "distribution.settings_form.note_hint": "Leave empty and save to clear the note.",
  "distribution.settings_form.changes": "{count, plural, one {# change} other {# changes}}",
  "distribution.settings_form.discard": "Discard changes",
  "distribution.settings_form.no_rights_title": "Read only",

  "distribution.issue.schema": "Schema error",
  "distribution.issue.timeout": "Timeout; outcome unknown",
  "distribution.issue.channel.listing_limit_reached": "Outside the listing limit",
  "distribution.issue.kyero.type_not_supported": "Property type not supported by Kyero",
  "distribution.issue.kyero.offer_kind_not_supported": "Holiday lets not supported by Kyero",
  "distribution.issue.kyero.price_on_request_not_supported": "Price on request not allowed",
  "distribution.issue.kyero.currency_not_supported": "Currency not supported",
  "distribution.issue.kyero.price_too_long": "Price too long for the format",
  "distribution.issue.kyero.location_incomplete": "Town or province missing",
  "distribution.issue.kyero.no_images": "No usable photos",
  "distribution.issue.jamesedition.type_not_supported": "Property type not supported by JamesEdition",
  "distribution.issue.jamesedition.holiday_let_not_supported": "Holiday lets not supported",
  "distribution.issue.jamesedition.city_missing": "Town missing",
  "distribution.issue.jamesedition.min_two_images": "At least two photos needed",
  "distribution.issue.kyero.unknown_type": "Unknown property type",
  "distribution.issue.kyero.unknown_price_freq": "Unknown price frequency",
  "distribution.issue.kyero.unknown_language": "Unknown language code",
  "distribution.issue.kyero.unknown_country": "Unknown country",
  "distribution.issue.kyero.unexpected_version": "Unexpected feed version",
  "distribution.issue.kyero.no_root": "Not a valid Kyero file",
  "distribution.issue.kyero.no_interpreted_as_nb": "Language code no read as Norwegian (nb)",
  "distribution.issue.kyero.missing_id": "Property without ID skipped",
  "distribution.issue.kyero.invalid_price": "Invalid price",
  "distribution.issue.kyero.invalid_currency": "Invalid currency",
  "distribution.issue.json.schema": "File does not match the BRES JSON schema",
  "distribution.issue.json.property_schema": "Property does not match the schema",
  "distribution.issue.json.invalid": "Not valid JSON",
  "distribution.issue.csv.missing_external_id": "Row without external ID",
  "distribution.issue.csv.missing_columns": "Required columns missing",
  "distribution.issue.csv.ambiguous_amount": "Amount is ambiguous",
  "distribution.issue.import.invalid_reference": "Invalid reference",
  "distribution.issue.import.invalid_kind": "Invalid property type",
  "distribution.issue.import.invalid_offer_kind": "Invalid offer type",
  "distribution.issue.import.invalid_currency": "Invalid currency",
  "distribution.issue.import.price_missing": "Price missing",
  "distribution.issue.import.price_not_positive": "Price must be above zero",
  "distribution.issue.import.country_missing": "Country missing",
  "distribution.issue.import.locality_missing": "Town missing",
  "distribution.issue.import.area_implausible": "Area implausible",
  "distribution.issue.import.bedrooms_implausible": "Number of bedrooms implausible",
  "distribution.issue.import.bedrooms_for_non_dwelling": "Bedrooms on a non-residential property",
  "distribution.issue.import.unknown_features": "Unknown features ignored",
  "distribution.issue.import.duplicate_external_id": "External ID appears twice",
  "distribution.issue.import.reference_exists_unlinked": "Reference already exists in BRES, but not from this source",
  "distribution.issue.import.missing_in_complete_snapshot": "Missing from the full source",
  "distribution.issue.import.mass_withdrawal": "Many properties are missing from this source",
  "distribution.issue.import.empty_feed": "Empty source; nothing is withdrawn",
  "distribution.issue.import.apply_failed": "Apply failed",
  "distribution.issue.import.no_input": "No file or address",
  "distribution.issue.fetch.http_status": "Source returned an error status",
  "distribution.issue.fetch.failed": "Fetching failed",
  "distribution.issue.parse.failed": "File could not be read",

  "distribution.imports.title": "Imports",
  "distribution.imports.waiting": "{count, plural, one {# awaiting review} other {# awaiting review}}",
  "distribution.imports.count": "{count, plural, one {# run} other {# runs}}",

  "distribution.sources.title": "Sources",
  "distribution.sources.add": "Add source",
  "distribution.sources.empty_title": "No import source yet",
  "distribution.sources.empty_body": "Add a source, such as a partner's Kyero feed or a spreadsheet.",
  "distribution.sources.linked": "{count, plural, =0 {no properties linked yet} one {# property linked} other {# properties linked}}",
  "distribution.sources.bres_owns": "BRES manages: {groups}",
  "distribution.sources.source_owns_all": "Source manages all fields",
  "distribution.sources.default_rights": "New properties get rights for {rights}",
  "distribution.sources.no_default_rights": "New properties get no rights",
  "distribution.sources.right_website": "Website right",
  "distribution.sources.right_portal": "Portal right",
  "distribution.sources.right_website_short": "the website",
  "distribution.sources.right_portal_short": "portals",
  "distribution.sources.paused": "Paused",
  "distribution.sources.add_title": "Add import source",
  "distribution.sources.edit_title": "Edit import source",
  "distribution.sources.edit_body": "Changed settings require a new dry run.",
  "distribution.sources.updated": "Import source saved",
  "distribution.sources.active": "Source active",
  "distribution.sources.add_body": "A source changes nothing without a dry run and your approval.",
  "distribution.sources.add_submit": "Add source",
  "distribution.sources.name": "Name",
  "distribution.sources.adapter": "Format",
  "distribution.sources.transport": "Delivery",
  "distribution.sources.url": "Address (https)",
  "distribution.sources.url_invalid": "Use a full https address.",
  "distribution.sources.hosts": "Allowed hosts",
  "distribution.sources.media_hosts_hint": "Hosts for photos in this source, separated by commas.",
  "distribution.sources.hosts_hint": "Separated by commas. Empty means only {host}.",
  "distribution.sources.rights": "Rights for new properties",
  "distribution.sources.rights_hint": "Only tick these if the source grants you those rights in writing.",
  "distribution.sources.authority": "Source of truth per field group",
  "distribution.sources.authority_hint": "With Source, an import takes over changes. With BRES, your values stay.",
  "distribution.sources.owner_source": "Source",
  "distribution.sources.owner_bres": "BRES",
  "distribution.sources.created": "Source {name} added",

  "distribution.adapter.kyero_v3": "Kyero XML v3",
  "distribution.adapter.bres_json_v1": "BRES JSON v1",
  "distribution.adapter.bres_csv_v1": "BRES CSV v1",

  "distribution.adapter_hint.kyero_v3": "Full feed following the Kyero import specification.",
  "distribution.adapter_hint.bres_json_v1": "BRES's own versioned contract.",
  "distribution.adapter_hint.bres_csv_v1": "Spreadsheet with the BRES columns.",

  "distribution.transport.upload": "Upload a file",
  "distribution.transport.https_pull": "Fetch via https",

  "distribution.group.identity": "Reference and type",
  "distribution.group.price": "Price",
  "distribution.group.status": "Status",
  "distribution.group.facts": "Features",
  "distribution.group.location": "Location",
  "distribution.group.texts": "Texts",
  "distribution.group.media": "Photos",

  "distribution.dry_run.action": "Start dry run",
  "distribution.dry_run.title": "Start dry run",
  "distribution.dry_run.lead": "A dry run changes nothing. You first see per property what would change.",
  "distribution.dry_run.drop": "Drop a file here",
  "distribution.dry_run.choose": "Choose file",
  "distribution.dry_run.other_file": "Other file",
  "distribution.dry_run.too_large": "File is larger than 60 MB.",
  "distribution.dry_run.accepts_kyero_v3": "XML file, up to 60 MB",
  "distribution.dry_run.accepts_bres_json_v1": "JSON file, up to 60 MB",
  "distribution.dry_run.accepts_bres_csv_v1": "CSV file, up to 60 MB",
  "distribution.dry_run.pull_title": "BRES fetches the file",
  "distribution.dry_run.pull_hosts": "Allowed hosts: {hosts}",
  "distribution.dry_run.submit": "Start dry run",
  "distribution.dry_run.started": "Dry run started",

  "distribution.runs.title": "Runs",
  "distribution.runs.col_status": "Status",
  "distribution.runs.col_source": "Source",
  "distribution.runs.col_changes": "Differences",
  "distribution.runs.col_items": "Records",
  "distribution.runs.col_file": "File",
  "distribution.runs.col_created": "Started",
  "distribution.runs.empty_title": "No runs yet",
  "distribution.runs.empty_body": "Start a dry run on a source to see the differences.",
  "distribution.runs.col_run": "Run",
  "distribution.runs.all_statuses": "All",
  "distribution.runs.all_sources": "All sources",
  "distribution.runs.clear": "Clear filters",
  "distribution.runs.empty_filtered_title": "No runs with this filter",
  "distribution.runs.empty_filtered_body": "Clear the filters to see all runs.",

  "distribution.run_status.fetching": "Fetching file",
  "distribution.run_status.diffing": "Finding differences",
  "distribution.run_status.awaiting_review": "Awaiting review",
  "distribution.run_status.applying": "Applying",
  "distribution.run_status.applied": "Applied",
  "distribution.run_status.failed": "Failed",
  "distribution.run_status.rejected": "Rejected",
  "distribution.run_status.superseded": "Replaced",

  "distribution.trigger.manual": "Manual",
  "distribution.trigger.schedule": "Scheduled",
  "distribution.trigger.upload": "Upload",

  "distribution.count.create": "{count} new",
  "distribution.count.update": "{count} changed",
  "distribution.count.unchanged": "{count} unchanged",
  "distribution.count.withdraw": "{count} missing",
  "distribution.count.quarantine": "{count} in quarantine",
  "distribution.count.conflict": "{count, plural, one {# conflict} other {# conflicts}}",
  "distribution.count.applied": "{count} applied",
  "distribution.count.failed": "{count} failed",

  "distribution.action.create": "New",
  "distribution.action.update": "Changed",
  "distribution.action.unchanged": "Unchanged",
  "distribution.action.withdraw": "Missing from source",
  "distribution.action.quarantine": "Quarantine",
  "distribution.action.conflict": "Conflict",

  "distribution.run.crumb": "Import run",
  "distribution.run.title": "Dry run {source}",
  "distribution.run.title_loading": "Import run",
  "distribution.run.processing": "The worker is processing the file. This page refreshes by itself.",
  "distribution.run.failed_title": "This run failed",
  "distribution.run.errors": "Errors",
  "distribution.run.warnings_title": "Please note",
  "distribution.run.applied_title": "{count, plural, one {# change applied} other {# changes applied}}",
  "distribution.run.applied_body": "{failed, plural, =0 {Nothing failed.} one {# failed.} other {# failed.}} Approved by {by} on {time}.",
  "distribution.run.rejected_title": "Rejected",
  "distribution.run.rejected_body": "Nothing was changed. Start a new dry run once the source has been fixed.",
  "distribution.run.rejected_toast": "Run rejected",
  "distribution.run.summary": "Summary",
  "distribution.run.facts": "Details",
  "distribution.run.trigger": "Trigger",
  "distribution.run.started": "Started",
  "distribution.run.hash": "Source file (SHA-256)",
  "distribution.run.snapshot": "Source scope",
  "distribution.run.snapshot_complete": "Full snapshot",
  "distribution.run.snapshot_partial": "Partial",
  "distribution.run.bres_owns": "BRES is the source of truth for",
  "distribution.run.filter": "Filter by type",
  "distribution.run.withdraw_note": "Missing properties are never deleted. After your approval only the offer is set to withdrawn.",
  "distribution.run.apply": "Apply",
  "distribution.run.reject": "Reject",
  "distribution.run.reject_title": "Reject this dry run?",
  "distribution.run.reject_body": "Nothing is applied. The run stays visible as rejected.",
  "distribution.run.reject_confirm": "Reject run",
  "distribution.run.records": "{count, plural, one {# record} other {# records}}",

  "distribution.items.label": "Records in this run",
  "distribution.items.col_item": "Record",
  "distribution.items.col_action": "Type",
  "distribution.items.col_details": "Changes and messages",
  "distribution.items.col_decision": "Decision",
  "distribution.items.external": "ext. {id}",
  "distribution.items.create": "New property.",
  "distribution.items.created": "New property created in BRES.",
  "distribution.items.unchanged": "No differences.",
  "distribution.items.withdraw": "Missing from the full source. Only after your approval is the offer set to withdrawn; the property stays.",
  "distribution.items.issues": "Messages",
  "distribution.items.empty_title": "Nothing for this filter",
  "distribution.items.empty_body": "There are no records for this filter.",
  "distribution.items.search": "Search records",
  "distribution.items.search_placeholder": "Reference, external ID or town",
  "distribution.items.clear": "Clear filters",
  "distribution.items.none_title": "No records",
  "distribution.items.none_body": "This run has no records.",

  "distribution.decision.pending_apply": "Will be applied",
  "distribution.decision.pending_withdraw": "Awaiting approval",
  "distribution.decision.pending_blocked": "Cannot be applied",
  "distribution.decision.not_applied": "Not applied",
  "distribution.decision.accepted": "Accepted",
  "distribution.decision.rejected": "Rejected",
  "distribution.decision.applied": "Applied",
  "distribution.decision.skipped": "Skipped",

  "distribution.decide.label": "Decisions for selection",
  "distribution.decide.accept": "Accept",
  "distribution.decide.reject": "Reject",
  "distribution.decide.accepted": "{count, plural, =0 {Nothing accepted} one {# record accepted} other {# records accepted}}",
  "distribution.decide.rejected": "{count, plural, =0 {Nothing rejected} one {# record rejected} other {# records rejected}}",
  "distribution.decide.skipped": "{count, plural, one {# skipped: you cannot accept quarantine or conflicts.} other {# skipped: you cannot accept quarantine or conflicts.}}",

  "distribution.diff.label": "Field differences",
  "distribution.diff.empty": "empty",
  "distribution.diff.becomes": "becomes",
  "distribution.diff.blocked_lock": "locked in BRES",
  "distribution.diff.blocked_authority": "BRES is source of truth",

  "distribution.field.reference": "Reference",
  "distribution.field.kind": "Type",
  "distribution.field.offer_amountMinor": "Price",
  "distribution.field.offer_currency": "Currency",
  "distribution.field.offer_priceOnRequest": "Price on request",
  "distribution.field.offer_status": "Status",
  "distribution.field.offer_kind": "Offer",
  "distribution.field.offer_period": "Price period",
  "distribution.field.views": "Views",
  "distribution.field.country": "Country",
  "distribution.field.bedrooms": "Bedrooms",
  "distribution.field.bathrooms": "Bathrooms",
  "distribution.field.builtM2": "Built",
  "distribution.field.plotM2": "Plot",
  "distribution.field.yearBuilt": "Year built",
  "distribution.field.features": "Features",
  "distribution.field.energyRating": "Energy rating",
  "distribution.field.locality": "Town",
  "distribution.field.municipality": "Municipality",
  "distribution.field.province": "Province",

  "distribution.apply.title": "Apply dry run",
  "distribution.apply.withdrawals_skipped": "{count, plural, one {# withdrawal proposal without approval stays open} other {# withdrawal proposals without approval stay open}}",
  "distribution.apply.blocked": "{count, plural, one {# record in quarantine or conflict is left out} other {# records in quarantine or conflict are left out}}",
  "distribution.apply.hash_note": "Only if the source file has not changed since the dry run:",
  "distribution.apply.decide_first_title": "Decide on the withdrawal proposals first",
  "distribution.apply.decide_first": "{count, plural, one {# withdrawal proposal is still open.} other {# withdrawal proposals are still open.}} With this many missing properties you accept or reject each proposal separately.",
  "distribution.apply.confirm_withdrawals": "{count, plural, one {I confirm # withdrawal} other {I confirm # withdrawals}}",
  "distribution.apply.nothing": "There is nothing to apply.",
  "distribution.apply.submit": "{count, plural, =0 {Apply} one {Apply # change} other {Apply # changes}}",
  "distribution.apply.done": "{count, plural, =0 {Nothing applied} one {# change applied} other {# changes applied}}",
  "distribution.apply.failed": "{count, plural, one {# failed; see the message on the record} other {# failed; see the messages on the records}}",
  "distribution.apply.rejected": "{count, plural, one {# record rejected, stays unchanged} other {# records rejected, stay unchanged}}",

  "distribution.apply_error.import.source_changed_title": "Source has changed",
  "distribution.apply_error.import.source_changed": "The source file changed after this dry run, so BRES does not apply it. Start a new dry run and review the differences again.",
  "distribution.apply_error.import.mass_withdrawal_unconfirmed_title": "Withdrawals not confirmed",
  "distribution.apply_error.import.mass_withdrawal_unconfirmed": "Many properties are missing from the source. Decide on each withdrawal proposal and confirm the withdrawals.",
  "distribution.apply_error.import.not_awaiting_review_title": "Run already handled",
  "distribution.apply_error.import.not_awaiting_review": "This run was already applied or rejected. Refresh the page.",

  "distribution.progress.label": "Publication progress",
  "distribution.progress.step_snapshot": "Snapshot",
  "distribution.progress.step_build": "Build",
  "distribution.progress.step_checks": "Checks",
  "distribution.progress.step_live": "Live",
  "distribution.progress.state_done": "done",
  "distribution.progress.state_active": "in progress",
  "distribution.progress.state_waiting": "queued",
  "distribution.progress.state_failed": "failed",
  "distribution.progress.state_todo": "not started",
  "distribution.progress.queued": "Queued at the build server",
  "distribution.progress.running": "Building, {duration}",
  "distribution.progress.done": "Live in {duration}",
  "distribution.progress.failed": "Failed; the previous version stays live",
  "distribution.progress.superseded": "Superseded by a newer publication",
  "distribution.progress.excluded": "{count, plural, one {# property excluded} other {# properties excluded}}",
  "distribution.progress.details": "Details",
  "distribution.progress.dismiss": "Close progress",

  "distribution.history.title": "History",
  "distribution.history.channel": "Channel",
  "distribution.history.all_channels": "All channels",
  "distribution.history.show": "Show",
  "distribution.history.show_all": "Everything",
  "distribution.history.show_builds": "Builds",
  "distribution.history.show_withdrawals": "Emergency withdrawals",
  "distribution.history.withdrawal_title": "{reference} taken off the website",
  "distribution.history.empty_title": "Nothing published yet",
  "distribution.history.empty_body": "Every publication appears here with status, duration and checks.",
  "distribution.history.empty_filtered_title": "Nothing for this filter",
  "distribution.history.empty_filtered_body": "Pick another channel or show everything.",
  "distribution.history.clear": "Show everything",

  "distribution.rejections.title": "{count, plural, one {# rejection} other {# rejections}}",
  "distribution.rejections.no_reason": "No reason given",

  "distribution.plan.title": "When applied",
  "distribution.plan.creates": "{count, plural, one {new property} other {new properties}}",
  "distribution.plan.updates": "{count, plural, one {property updated} other {properties updated}}",
  "distribution.plan.withdrawals": "{count, plural, one {offer withdrawn} other {offers withdrawn}}",
  "distribution.plan.no_rights": "Only owners and administrators apply imports."
}
